<template>
  <footer class="page-footer">
    <div class="page-footer__inner">
      <div class="page-footer__logos">
        <img
          src="/img/img-footer-mobile.png"
          alt="Revendedores Grupo Boticário e PGMais"
          class="page-footer__logo"
        />
      </div>
      <p class="page-footer__text">
        &copy; {{ year }} Grupo Boticário. Todos os direitos reservados.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.page-footer {
  background-color: #efefef;
  padding: 20px 0;
  margin-top: auto;
}
.page-footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;
  box-sizing: border-box;
}

.page-footer__logos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}

.page-footer__logo {
  display: block;
  width: 100%;
  max-width: 280px;
  height: auto;
}

/* Mobile: só imagem */
.page-footer__text {
  display: none;
}

@media (min-width: 768px) {
  .page-footer__inner {
    max-width: var(--negotiation-layout-max-width, 960px);
    padding: 0 24px;
  }

  /* Desktop: só texto */
  .page-footer__logos {
    display: none;
  }

  .page-footer__text {
    display: block;
    margin: 0;
    font-family: 'Inter', sans-serif;
    font-size: 0.8rem;
    color: #555;
  }
}
</style>
